import React, {useEffect} from 'react';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import PreviewPage from "@/pages/PreviewPage.jsx";
import {ContestPage} from "@/pages/ContestPage.jsx";
import DemoPage from "@/pages/DemoPage.jsx";
import {RulesPage} from "@/pages/RulesPage.jsx";
import TermsPage from "@/pages/TermsPage.jsx";
import BrandDemoPage from "@/pages/BrandDemoPage.jsx";
import { HOLY_CONFIG } from "@/features/brandDemo/configs/holy.js";
import { RHINOSHIELD_CONFIG } from "@/features/brandDemo/configs/rhinoshield.js";
import { GRUPPOMIMO_CONFIG } from "@/features/brandDemo/configs/gruppomimo.js";
import DemoQuizzPage from "@/pages/DemoQuizzPage.jsx";
import UnsubscribePage from "@/pages/UnsubscribePage.jsx";
import {ReferralSharePage} from "@/pages/ReferralSharePage.jsx";

const RedirectToLanding = () => {
    useEffect(() => {
        window.location.replace(`${import.meta.env.VITE_ADMIN_URL}/landing`);
    }, []);

    return (
        <div className="flex h-screen items-center justify-center bg-slate-900 text-white">

        </div>
    );
};

export default function GojoApp() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/demo" element={<DemoPage/>}/>
                <Route path="/holy" element={<BrandDemoPage config={HOLY_CONFIG}/>}/>
                <Route path="/rhinoshield" element={<BrandDemoPage config={RHINOSHIELD_CONFIG}/>}/>
                <Route path="/gruppomimo" element={<BrandDemoPage config={GRUPPOMIMO_CONFIG}/>}/>
                <Route path="/preview" element={<PreviewPage/>}/>
                <Route path="/rules" element={<RulesPage/>}/>
                <Route path="/cgu" element={<TermsPage/>}/>
                <Route path="/demo-quizz" element={<DemoQuizzPage />} />
                <Route path="/demo-invite" element={
                    <ReferralSharePage demoData={{
                        code: 'DEMO1234',
                        coverUrl: 'https://images.gojokodo.com/lasphalte-cover.jpg',
                        hasPlayed: false,
                        referral: {
                            valid: true,
                            referrerRewardTitle: '1 boisson achetée = 1 offerte',
                            refereeRewardTitle: '1 shot offert',
                            organizationSlug: 'demo',
                            organizationName: 'Le Biltoki',
                            organizationLogoUrl: null,
                            referrerCap: 3,
                            referralsUsed: 1,
                        },
                    }}/>
                }/>
                <Route path="/unsubscribe" element={<UnsubscribePage/>}/>

                {/* Page de partage du parrain (bouton "Partager à un ami" de l'email) — partage natif OS.
                    Le code seul identifie l'org (pas de slug dans l'URL). */}
                <Route path="/invite/:code" element={<ReferralSharePage/>}/>

                {/* Redirige l'URL classique vers ContestPage */}
                <Route path="/:slug" element={<ContestPage/>}/>

                <Route path="/:slug/:contestId" element={<ContestPage/>}/>

                <Route path="/" element={<RedirectToLanding/>}/>

                {/* Page 404 */}
                <Route path="*" element={<div>Page introuvable</div>}/>
            </Routes>
        </BrowserRouter>
    );
}